"use strict";

(function (angular) {
  "use strict";

  angular.module("fleetviewApp").component("loginForm", {
    template: require("./login_form.html"),
    controller: LoginController
  });

  LoginController.$inject = ["$location", "$window", "alkAuthenticationService", "$rootScope", "UserProvider", "ALKLogin"];

  function LoginController($location, $window, alkAuthenticationService, $rootScope, UserProvider, ALKLogin) {
    var vm = this;

    vm.isProcessing = false;

    vm.userInfo = {};
    vm.isEmailFocused = true;
    vm.accounts = [];

    vm.isIE9 = $window.isIE9 != null;
    vm.isltIE9 = $window.isltIE9 != null;

    vm.login = login;

    vm.forgotPassword = forgotPassword;

    function forgotPassword() {
      $rootScope.$broadcast("forgotPassword");
    }

    function login(userInfo) {
      vm.showPasswordIncorrect = false;
      vm.showNoAccountForApplication = false;
      vm.showAccountDisabled = false;

      // remove the user from session before attempting to sign in a new user
      UserProvider.clearUser();

      var login = new ALKLogin(vm.userInfo.username, vm.userInfo.password, vm.userInfo.account);
      if (!login.isBaseValid()) return;

      if (vm.accounts.length > 0 && !login.isAccountValid()) return;

      vm.isProcessing = true;

      alkAuthenticationService.login(login).then(function () {
        return loginSuccess();
      }, function (error) {
        return loginFailed(error);
      });
    }

    function loginSuccess() {
      var redirectTo = "/app/dashboard";

      if ($location.search().r) {
        redirectTo = decodeURIComponent($location.search().r);
      }

      $location.url(redirectTo);
    }

    function loginFailed(error) {
      // if the authorization fails and the service sends back a list of accounts, this means the username/password was correct, but there was more than one account for this user for this application.
      // display the list of accounts to the user so they can select one and continue.

      // on failed login - reset the list of accounts.
      vm.accounts = [];
      delete vm.userInfo.account;

      console.log("error logging in ", error);

      if (error.status !== null && error.status === "FailedToLoginDueToMultipleAccounts" && error.accounts.length > 0) {
        vm.accounts = error.accounts;
        vm.userInfo.account = vm.accounts[0].accountName;
      } else if (error.status !== null && error.status === "FailedToLogin") {
        vm.showPasswordIncorrect = true;
      } else if (error.status !== null && error.status === "FailedToLoginNotAuthorized") {
        vm.showNoAccountForApplication = true;
      } else {
        vm.showPasswordIncorrect = true;
      }

      vm.isProcessing = false;
    }
  }
})(window.angular);


// WEBPACK FOOTER //
// ./app/auth/login.controller.js